import { render, staticRenderFns } from "./LogEventosMID.vue?vue&type=template&id=45557968&"
import script from "./LogEventosMID.vue?vue&type=script&lang=ts&"
export * from "./LogEventosMID.vue?vue&type=script&lang=ts&"
import style0 from "./LogEventosMID.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports